import { Component } from '@angular/core';

@Component({
    selector: 'bl-empty-component',
    template: '',
    standalone: false
})
export class EmptyComponent {}
